import { useMutation } from 'react-query';

export default function useDiscoveryLogin() {
  return useMutation(async (accountId: string) => {
    const response = await fetch(`/auth/stytch/discovery/login/${accountId}`, {
      method: 'POST',
    });

    if (response.ok) {
      return { isSuccess: true };
    } else {
      const data = await response.json();
      return { isSuccess: false, error: data.error };
    }
  });
}
